import React from 'react'
import CourseLmsList from '../../features/addlms/CourseLmsList'

const CourseLmsListPage = () => {
  return (
    <CourseLmsList/>
  )
}

export default CourseLmsListPage
